export const STATUS = {
    waiting: 'time',
    accepted: 'checkbox',
    rejected: 'close-circle',
}

export const STATUS_CLASS = {
    waiting: 'warning',
    accepted: 'success',
    rejected: 'danger',
}
